import { render } from "./BigNumber.vue?vue&type=template&id=44cfbe20&lang=pug"
import script from "./BigNumber.vue?vue&type=script&lang=js"
export * from "./BigNumber.vue?vue&type=script&lang=js"

import "./BigNumber.vue?vue&type=style&index=0&id=44cfbe20&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__